// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_g2-2";
export var aiChatCartContainerExit = "_g2-4";
export var aiChatContainerLarge = "_g2-0";
export var aiChatContainerSmall = "_g2-1";
export var aiChatIcon = "_g2-6";
export var slideInFromRight = "_g2-3";
export var slideOutToRight = "_g2-5";